import { List } from 'immutable';
import { Component, OnInit, Input, ViewChild, ChangeDetectorRef } from '@angular/core';
import { BaseEntity, BaseInlineContainer, DefaultButtonsConfig, InlineContainerService, UserService, QueryParameter} from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { EOtpremnicaStavkaInlineUpdateComponent } from './eotpremnica-stavka-inline-update.component';

//import { PARAMETERS } from '@angular/core/src/util/decorators';

@Component({
  selector: 'yt-eotpremnica-stavka-dodatni-atribut-update-container',
  templateUrl: './eotpremnica-stavka-dodatni-atribut-update-container.component.html',
  providers: [
    InlineContainerService
  ]
})
export class EOtpremnicaStavkaDodatniAtributUpdateContainer<T extends BaseEntity> 
extends BaseInlineContainer<T> {

  constructor(inlineContainerService: InlineContainerService<T>,
              activatedRoute: ActivatedRoute,
              userService: UserService,
              ){
super(inlineContainerService, activatedRoute, userService);
}
@Input() Level: 'document' | 'item' | 'attribute' = 'document';

  @ViewChild("baseDetailList", { static: false }) baseDetailList: any;

  @Input() NestedInline: boolean = false;

  @Input() Disabled: boolean = false;

  tempItems: List<T>
  izlazna: boolean = false;
  
  ngAfterViewInit() {
    if (this.baseDetailList.tableConfig) {
      this.izlazna=this.modelData.MainList.FormControlDataName=="eotpremnice/izeotpremnica";

      this.baseDetailList.tableConfig.ShowCheckBoxes = false;
      this.baseDetailList.tableConfig.DefaultListButtonsConfig.AddButtonConfig.Visible=this.izlazna;
      this.baseDetailList.tableConfig.DefaultListButtonsConfig.DeleteAllButtonConfig = false;
      this.baseDetailList.tableConfig.DefaultListButtonsConfig.PrintButtonConfig = false;
      this.baseDetailList.tableConfig.DeleteIcon.Visible = this.izlazna;
      
    }
  }

   
  setItems(items) {
    this.tempItems = items;
    }


  }


